/* eslint-disable no-unused-vars */
import { ReactComponent as CheckGreenIcon } from "assets/images/iconsV2/check-circle-green.svg";
import { ReactComponent as XCircleRedIcon } from "assets/images/iconsV2/x-circle-red.svg";
import { ReactComponent as ClockOrangeIcon } from "assets/images/iconsV2/clock-orange.svg";
import { ReactComponent as ClockIcon } from "assets/images/iconsV2/clock.svg";
import { ReactComponent as ArrowCircleRightIcon } from "assets/images/iconsV2/arrow-circle-right.svg";

const ApprovalUpdateItemOptions: {
  [key in ApprovalUpdateItemStatusType]: { icon: React.ReactNode; label: string; className: string };
} = {
  approved: { icon: <CheckGreenIcon width={17} height={16} />, label: "Approved", className: "text-success-primary" },
  booked: { icon: <CheckGreenIcon width={17} height={16} />, label: "Booked", className: "text-success-primary" },
  rejected: { icon: <XCircleRedIcon />, label: "Rejected", className: "text-error-primary" },
  canceled: { icon: <XCircleRedIcon />, label: "Canceled", className: "text-error-primary" },
  pending_approval: { icon: <ClockOrangeIcon />, label: "Pending approval", className: "text-warning-primary" },
  pending_previous_approval: { icon: <ClockIcon />, label: "Pending previous approval", className: "text-tertiary" },
  approval_transferred: { icon: <ArrowCircleRightIcon />, label: "Approval transferred", className: "text-tertiary" },
};

export type ApprovalUpdateItemStatusType =
  | "approved"
  | "booked"
  | "rejected"
  | "canceled"
  | "pending_approval"
  | "pending_previous_approval"
  | "approval_transferred";

type ApprovalUpdateItemStatusProps = {
  status: ApprovalUpdateItemStatusType;
  additionalData?: Record<string, any>;
};

function ApprovalUpdateItemStatus({ status, additionalData }: ApprovalUpdateItemStatusProps) {
  const { icon, label, className } = ApprovalUpdateItemOptions[status];

  return (
    <div className="d-flex align-items-center">
      {icon}
      <div className={`text-xs font-medium ${className} ml-xs`}>
        {label}{" "}
        {status === "approval_transferred" && additionalData?.transferredUsers && (
          <span>to {additionalData.transferredUsers}</span>
        )}
      </div>
    </div>
  );
}

export default ApprovalUpdateItemStatus;

ApprovalUpdateItemStatus.defaultProps = {
  additionalData: undefined,
};
